
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
    name: 'MessageImageBlock',

    computed: {
        isImageContain() {
            return Boolean(Number.parseFloat(this.cfgs?.image_contain || 0) === 1);
        },
    },

    methods: {
        openPopUpImages() {
            this.$store.commit('pop-up-images/setImages', [this.values.image]);
        },
    },
});
